import { FC, useLayoutEffect, useState } from "react";
import { Router } from "react-router-dom";
import type { BrowserHistory } from "history";

const AppRouter: FC<{ history: BrowserHistory }> = ({ history, ...props }) => {
  const [state, setState] = useState({
    action: history.action,
    location: history.location,
  });

  useLayoutEffect(() => history.listen(setState), []);

  return (
    <Router
      {...props}
      location={state.location}
      navigationType={state.action}
      navigator={history}
    />
  );
};

export default AppRouter;
